import LinkHandler from './kiosk-mode.js';
import Anchor from './../../legacy-vue/shared/scripts/anchor.js';

(() => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('kioskMode') === 'true') {
    new LinkHandler();
  }

  new Anchor();
})();
